{
  "version": 1,
  "asset_id": "9c596561-61bb-4ec1-9088-71a5571604db",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/9c596561-61bb-4ec1-9088-71a5571604db/venue-pool-rafters.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/9c596561-61bb-4ec1-9088-71a5571604db/venue-pool-rafters.webp",
  "original_filename": "venue-pool-rafters.webp",
  "size": 192088,
  "content_type": "image/webp",
  "created_at": "2026-07-04T16:13:21Z"
}
